export const timeOffsTypes = [
    "Sick", 
    "Vacation", 
    "Bereavement", 
    "Jury Duty", 
    "Military", 
    "Maternity/Paternity", 
    "Other", 
];

export type Status = "Submitted" | "Re-Submitted" | "Approved" | "Rejected";
export type TimeOff = {
    id: number, 

    fromDate: string, 
    toDate: string, 
    notes: string,
    status: Status,

    requesterId: string, 
    requesterName: string, 

    requester: {
        label: string,
        value: string,
        department: string, 
        outside: string, 
        projects: string
    },

    notifiedAt: string,
    notifiedBy: string,

    approverId: string, 
    approverName: string,
    approvalTime: string
    approverNotes: string,

    approver: {
        label: string,
        value: string
    } | null,

    creatorId: string, 
    creatorName: string,
    createdAt: string, 

    updaterId: string,
    updaterName: string,
    updatedAt: string,

    void: "yes" | "no",
    data: string, 
    totalHours: number, 
    department: string, 
    type: typeof timeOffsTypes[number],

    pdfId: string,
    paid: "yes" | "no", 

    requestDates: string, 
};
export type Data = {
    date: string, 
    holiday: string, 
    holidayName: string, 
    weekend: string, 
    startTime: string, 
    hours: string
};